import React from "react";
import { Upload, Settings, Users, Sparkles } from "lucide-react";
import { howItWorksSteps } from "../data/mockData";
import ProductDemo from "./ProductDemo";

const stepIcons = [Upload, Settings, Users, Sparkles];

const HowItWorksSection = () => {
  return (
    <section id="how-it-works" className="py-20 lg:py-32 bg-gradient-to-br from-slate-50 to-orange-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 mb-6">
            How QuillStudio
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-orange-500 to-pink-500">
              Works
            </span>
          </h2>
          {/* Product Demo Animation */}
          <div className="mt-16 max-w-5xl mx-auto">
            <div className="text-center mb-8">
              <h3 className="text-2xl font-bold text-slate-900 mb-4">
                See QuillStudio in Action
              </h3>
              <p className="text-slate-600">
                Watch how tags in your Word documents become real customer data in PDFs
              </p>
            </div>
            <ProductDemo />
          </div>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto mt-12">
            Get from Word document to professional PDF in just 3 simple steps
          </p>
        </div>

        {/* Steps */}
        <div className="relative">
          {/* Connection Line */}
          <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-0.5 bg-gradient-to-r from-orange-200 via-pink-200 to-orange-200 transform -translate-y-1/2"></div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {howItWorksSteps.map((step, index) => {
              const IconComponent = stepIcons[index];
              return (
                <div 
                  key={step.step}
                  className="relative text-center group"
                  style={{ animationDelay: `${index * 200}ms` }}
                >
                  {/* Step Number & Icon */}
                  <div className="relative mb-6">
                    <div className="inline-flex items-center justify-center w-20 h-20 bg-white rounded-full border-4 border-orange-200 shadow-lg group-hover:border-orange-400 transition-all duration-300 group-hover:scale-110">
                      <IconComponent className="text-orange-600 group-hover:text-orange-700 transition-colors duration-300" size={32} />
                    </div>
                    <div className="absolute -top-2 -right-2 w-8 h-8 bg-gradient-to-br from-orange-500 to-pink-500 text-white rounded-full flex items-center justify-center text-sm font-bold shadow-lg">
                      {step.step}
                    </div>
                  </div>

                  {/* Content */}
                  <div className="bg-white/60 backdrop-blur-sm p-6 rounded-xl border border-slate-200/50 group-hover:border-orange-200 transition-all duration-300 group-hover:shadow-lg">
                    <h3 className="text-lg font-bold text-slate-900 mb-3 group-hover:text-orange-700 transition-colors duration-300">
                      {step.title}
                    </h3>
                    <p className="text-slate-600 leading-relaxed">
                      {step.description}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-16">
          <p className="text-lg text-slate-600 mb-6">
            Ready to streamline your document generation?
          </p>
          <button 
            className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-orange-500 to-pink-500 text-white rounded-lg hover:from-orange-600 hover:to-pink-600 transition-all duration-300 transform hover:scale-105 font-semibold shadow-lg"
            onClick={() => window.open('https://appexchange.salesforce.com', '_blank')}
          >
            Start Your Free Trial
            <Sparkles className="ml-2" size={18} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;